import { RG_TYPE as r } from "@project-rouge/rg-core";
import { getBuildingBoundary as l } from "../../3d/boundary/index5.js";
import { getPolygonArea as u } from "../../geometry-utils/core/index14.js";
function d(e, n = [0]) {
  let i = 0;
  if (e.type === r.Building) {
    const t = l(e, n);
    i = u(t);
  } else
    e.type === r.Apartment ? e.children.filter((t) => t.type === r.Module).forEach((t) => {
      i += d(t);
    }) : i = e.size[0] * e.size[2];
  return i;
}
export {
  d as getHorizontalArea
};
//# sourceMappingURL=index2.js.map
